import React, {useEffect, useState,}  from "react";
import CustomizedRadios from './ViewMenuRadio'


import sceneBuild from '../collections/sceneBuild'
import Materials from '../collections/materials'

import useProgressiveImage from '../utils/progressiveLoad'





const Mask = ({ id, mask, multiply, children, size }) => (
    
    <div id={id}  style={{
        position: 'absolute',
        width: '100%',
        height: '100%',
        backgroundImage: `url(${children})`,
        backgroundSize: `${size}`,
        backgroundRepeat: 'round',
        backgroundPosition: 'center',

        WebkitMaskImage: `url(${mask})`,
        
        WebkitMaskSize: "100%",
        WebkitMaskMode: 'alpha',

        img: `url(${multiply})`, 
        mixBlendMode: 'multiply', 

        WebkitTransform: 'translate3d(0,0,0)',
        
        }}>
            {children}
    </div>
        
)


const Image = ({ id, children, size }) => (
    
    <div id={id} crossOrigin="anonymous" style={{
        position: 'absolute',
        width: '100%',
        height: '100%',
        backgroundImage: `url(${children})`,
        backgroundSize: `${size}%`,
        backgroundRepeat: 'round',
        backgroundPosition: 'center',
        
        
        }}
        >
            {children}
    </div>
        
)

const MaskNoMult = ({ mask, multiply, children, size }) => (
    
            <div style={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                backgroundImage: `url(${children})`,
                backgroundSize: `${size}`,
                backgroundRepeat: 'round',
                backgroundPosition: 'center',

                WebkitMaskImage: `url(${mask})`,
                
                WebkitMaskSize: "100%",
                WebkitMaskMode: 'alpha',

                img: `url(${multiply})`, 
                mixBlendMode: 'multiply', 
                //normal | multiply | screen | overlay | darken | lighten | color-dodge | color-burn | hard-light | soft-light | difference | exclusion | hue | saturation | color | luminosity
                }}>
                    {children}
            </div>
        
)

const Imageblur = ({ children, size }) => (
    
    <div  style={{
        position: 'absolute',
        width: '100%',
        height: '100%',
        transform: `translate(1%, 1%) rotate(30deg)`, 
        filter: 'blur(.1px)',
        opacity: '0.7'
        }}>
            {children}
    </div>
        
)

const TopMask = ({ mask, multiply, children }) => (
    
    <div  style={{
        position: 'absolute',
        width: '100%',
        height: '100%',
        backgroundImage: `url(${children})`,
        backgroundSize: '20%',
        backgroundRepeat: 'repeat',
        'WebkitTransform': 'rotate(-27deg)',
        'MozTransform': 'rotate(-27deg)',
        'MsTransform': 'rotate(-27deg)',
        'OTransform': 'rotate(-27deg)',
        'transform': 'rotate(-27deg)',
        
        backgroundPosition: 'center',
        
        }}>
            {children}
    </div>
)
const SideMask = ({ mask, multiply, children }) => (
    
    <div  style={{
        position: 'absolute',
        width: '100%',
        height: '100%',
        backgroundImage: `url(${children})`,
        backgroundSize: '20%',
        backgroundRepeat: 'repeat',
        'WebkitTransform': 'rotate(-27deg)',
        'MozTransform': 'rotate(-27deg)',
        'MsTransform': 'rotate(-27deg)',
        'OTransform': 'rotate(-27deg)',
        'transform': 'rotate(-27deg)',

        backfaceVisibility: 'hidden',

        backgroundPosition: 'center',

        }}>
            {children}
    </div>
)

const FrontMask = ({ mask, multiply, children }) => (
    
    <div style={{
        position: 'absolute',
        width: '100%',
        height: '100%',
        backgroundImage: `url(${children})`,
        backgroundSize: '20%',
        backgroundRepeat: 'repeat',
        'WebkitTransform': 'rotate(27deg)',
        'MozTransform': 'rotate(27deg)',
        'MsTransform': 'rotate(27deg)',
        'OTransform': 'rotate(27deg)',
        'transform': 'rotate(27deg)',
       
        backgroundPosition: 'center',

        }}>
            {children}
    </div>
)


const MaskRot1 = ({ mask, multiply, children }) => (
    
    <div id="maskRot"  style={{
        position: 'absolute',
        width: '100%',
        height: '100%',

        WebkitMaskImage: `url(${mask})`,
        backgroundPosition: 'content-box',
        WebkitMaskSize: "100%",

        img: `url(${multiply})`, 
        mixBlendMode: 'multiply', 
        backfaceVisibility: 'hidden',
        }}>
            {children}
    </div>
)



const sceneBuildFunc = ( matString, sch) => {

    const temp = sceneBuild.filter(v => v.view === matString).filter(v => v.scheme === sch).map(choice => choice.imageUrl.default)
    // setPlaceholderScene(temp)
    return temp
  }

  

  
const Room = (props) => {
    const [viewIndex, setViewIndex] = useState(2);
    const [mounted, setMounted] = useState(false);
    const {asyncLogParams } = props

    const materialNatureFunc = (index) => {
        const temp = Object.values(props.material).map(val => Materials.filter(v => v.name === val)[0].imageUrlTileRoom)
        // console.log("room materialfunc")
        return temp[3][index].default
      };

    const materialEntourageFunc = (index) => {
        const temp = Materials.filter(v => v.name === 'entourage')[0].imageUrlTileRoom
        // console.log("room materialEntourageFunc")
        return temp[index].default
    };
    
    useEffect(() => {
        if (mounted){
            asyncLogParams("Room scene", viewIndex)
        } else {
            setMounted(true)
        }
          
    }, [viewIndex])

    const materialFunc = () => {
        // debugger
        const temp = Object.values(props.material).map(val => Materials.filter(v => v.name === val)[0].imageUrlTile.default)
        return temp
      };

    let materialCache
    useEffect(() => {
        materialCache = materialSel[4]
    }, [])

    const placeholder = materialCache

    

    const materialSel = materialFunc()
    const sizeSwatch = 25

    const materialNatureSel = materialNatureFunc(viewIndex)
    const materialEntourageSel = materialEntourageFunc(viewIndex)
    const sceneBuild = sceneBuildFunc("Room", viewIndex)
    
    const loadedZ1 = useProgressiveImage(materialSel[0]) || placeholder
    const loadedZ2 = useProgressiveImage(materialSel[1]) || placeholder
    const loadedWood = useProgressiveImage(materialSel[2]) || placeholder
    const loadedTile = useProgressiveImage(materialSel[4]) || placeholder
    const loadedIndustry = useProgressiveImage(materialSel[5]) || placeholder

    return (    
        <div 
        id="RoomLayout"
        style={{
            position: "relative",
            height: "100%",
            width: "100%",
            backgroundColor: '#f3f3f3',
        }}>
            
            <div  id="RoomLayoutChild">
                <img  src={sceneBuild[0]} width='100%' alt='base' style={{img: `url(${sceneBuild[0]})`, mixBlendMode: 'multiply', width: '100%', position: "absolute" }}/>
                <img  src={sceneBuild[1]} width='100%' alt='otherbase' style={{img: `url(${sceneBuild[1]})`, mixBlendMode: 'multiply', width: '100%',  position: "absolute" }}/>
                
                <Mask id='roomZahner1Mask' mask={sceneBuild[2]} multiply={sceneBuild[1]} size={'25%'}> 
                    <Image id='zahner1' size={sizeSwatch} > 
                        {loadedZ1}
                    </Image>
                    <Imageblur>
                        <Image  size={sizeSwatch} > 
                            {loadedZ1}
                        </Image>
                    </Imageblur>
                </Mask> 

                <Mask id='roomZahner2Mask' mask={sceneBuild[3]} multiply={sceneBuild[1]} size={'25%'}> 
                    <Image  size={sizeSwatch} > 
                        {loadedZ2}
                    </Image>
                    <Imageblur>
                        <Image  size={sizeSwatch} > 
                            {loadedZ2}
                        </Image>
                    </Imageblur>
                </Mask>
                    
                <MaskRot1 id='roomWoodRot1Mask' mask={sceneBuild[4]} multiply={sceneBuild[1]}> 
                    <FrontMask mask={sceneBuild[8]} multiply={sceneBuild[1]}>
                        <Image  size={sizeSwatch} > 
                            {loadedWood}
                        </Image>
                    </FrontMask>
                </MaskRot1>

                <MaskRot1 id='roomWoodRot2Mask' mask={sceneBuild[7]} multiply={sceneBuild[1]}> 
                    <TopMask mask={sceneBuild[7]} multiply={sceneBuild[1]}>
                        <Image  size={sizeSwatch} > 
                            {loadedWood}
                        </Image>
                    </TopMask>
                </MaskRot1>

                <MaskRot1 id='roomWoodRot3Mask' mask={sceneBuild[8]} multiply={sceneBuild[1]} > 
                    <SideMask mask={sceneBuild[8]} multiply={sceneBuild[1]}>
                        <Image  size={sizeSwatch} > 
                            {loadedWood}
                        </Image>
                    </SideMask>
                </MaskRot1>
                

                <Mask  id='roomTileMask' mask={sceneBuild[5]} multiply={sceneBuild[1]} size={'25%'}>
                    <Image  size={sizeSwatch} > 
                        {loadedTile}
                    </Image>
                        {/* {materialSel[4]} */}
                </Mask>

                <Mask id='roomIndustryMask'  mask={sceneBuild[6]} multiply={sceneBuild[1]} size={'5%'}>
                    <Image  size={sizeSwatch} > 
                        {loadedIndustry}
                    </Image>
                </Mask>


                <div style={{ position: "absolute", 
                width: '100%',
                height: '100%',
                filter: 'drop-shadow(-5px 0px 4px rgba(50, 50, 50, .4))',
                }}>

                <MaskNoMult  id='roomPerfMask'  mask={sceneBuild[9]} multiply={sceneBuild[9]} size={'25%'} >
                    {materialSel[0]}
                </MaskNoMult>
                </div>

            </div>
                <img  src={materialEntourageSel} alt='entourage' style={{
                position: "absolute",
                width: '100%',
                filter: 'drop-shadow(-5px 0px 4px rgba(50, 50, 50, .4))',
                }}/>

                <img  src={materialNatureSel} alt='plant' style={{
                position: "absolute",
                width: '100%',
                filter: 'drop-shadow(-5px 0px 4px rgba(50, 50, 50, .4))',
                }}/>
                
            <div id='radioRoom' style={{height: '100%', width: '100%', 
            display: 'flex', 
            alignItems: 'flex-end', 
            marginLeft: '40%', 
            position: 'absolute', }}>
            <CustomizedRadios setViewIndex={setViewIndex} />
            </div>

            
        </div>


    )
}
// }

export default Room;